import React from 'react';
import Nav from '../Components/Nav';
import Footer from '../Components/Footer';
import Form from '../Components/Form';
import {
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText
  } from 'mdb-react-ui-kit';

export default function Contact() {

    return (
        <MDBContainer fluid className='text-center text-black mt-5'>
            <Nav />
                <MDBCard alignment='center' className='slideDown mx-auto mt-5' style={{width: '85vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}>
                        <MDBCardBody>
                            <MDBCardTitle>Contact Us</MDBCardTitle>
                            <MDBCardText className='slideDown py-5 mx-2 fs-5'>
                            We are excited to hear about your NFT project and how we can assist you with minting with Hedera. 
                            <br/>Please fill out a form and include relevant details about what you are building and how we can help.
                            <br/>If for any reason you are not receiving your NFTs or are experiencing payment issues, 
                            <br/>please submit a form explaining the issues you are having and we will get back to you within 24 hours..
                            </MDBCardText>
                            <Form />
                        </MDBCardBody>
                </MDBCard>
            <Footer className='pt-5'/>
        </MDBContainer>
    );
}